import _getBuiltIn from "../internals/get-built-in";
import _defineBuiltInAccessor from "../internals/define-built-in-accessor";
import _wellKnownSymbol from "../internals/well-known-symbol";
import _descriptors from "../internals/descriptors";
var exports = {};
var getBuiltIn = _getBuiltIn;
var defineBuiltInAccessor = _defineBuiltInAccessor;
var wellKnownSymbol = _wellKnownSymbol;
var DESCRIPTORS = _descriptors;
var SPECIES = wellKnownSymbol("species");
exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  }
};
export default exports;